import React, {Component} from 'react';
import {matchNode} from '../../utils/dom';
import stringUtils from '../../utils/string';


class SearchField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterOpen: false
        };

        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if(!prevState.filterOpen && this.state.filterOpen) {
            document.addEventListener('click', this.onClickHandler);
        }
        if(prevState.filterOpen && !this.state.filterOpen) {
            document.removeEventListener('click', this.onClickHandler);
        }
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.refs.searchInput) {
                this.refs.searchInput.focus();
            }
        }, 50);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onClickHandler);
    }

    onClickHandler(e) {
        let isInside = matchNode(e.target, this.refs.drop);
        if(!isInside || e.target.tagName === 'A') {
            return this.setState({filterOpen: false});
        }
        return null;
    }

    onChangeFilter(value) {
        this.setState({filterOpen: false});
        this.props.onChangeFilter(value);
    }

    onChangeSearch(event) {
        this.props.onChangeSearch(event.target.value);
    }

    render() {
        let FilterList;

        if(this.props.showFilter){
            FilterList = this.props.filterOptions.map((option) => {
                return (
                    <li key={option.key}>
                        <a
                            onClick={() => this.onChangeFilter(option.key)}
                        >{option.key}</a>
                    </li>
                );
            });
        }

        let filterLabel = (this.props.searchFilter.length < 1)
                        ? this.props.filterPlaceholder
                        : stringUtils.truncate(`${this.props.searchFilter}`, 20);

        let searchColClass = (this.props.showFilter)
                           ? 'col-sm-8 search'
                           : 'col-sm-12 search';

        return (
            <div className="row searchSelectListSearch">
                <div className={searchColClass}>
                    <div className="input-group">
                        <div className="input-group-addon searchIcon">
                            <img
                                src={require('./assets/searchIcon.png')}
                                alt={this.props.searchPlaceholder}
                            />
                        </div>
                        <input
                            ref="searchInput"
                            autoFocus={true}
                            type="text"
                            className="form-control"
                            placeholder={this.props.searchPlaceholder}
                            onChange={this.onChangeSearch}
                            value={this.props.searchValue}
                        />
                        <div className="input-group-addon">
                            <a
                                onClick={() => this.props.onChangeSearch('')}
                                className={this.props.searchValue
                                    ? 'clearSearchValue'
                                    : 'clearSearchValue off'
                            }>
                                <img
                                    src={require('../History/assets/clear.png')}
                                    alt="Clear Search"
                                />
                            </a>
                        </div>
                    </div>

                </div>
                {this.props.showFilter
                    ? <div className="col-sm-4 filter">
                        <div className="dropdown">
                            <div className="input-group">
                                <button
                                    className="btn-block btn-filter"
                                    disabled={this.props.filterOptions.length < 1}
                                    onClick={() => this.setState({
                                        filterOpen: !this.state.filterOpen
                                    })}
                                >
                                    <img
                                        src={require('./assets/searchIcon.png')}
                                        alt={this.props.filterPlaceholder}
                                    />
                                    {filterLabel}
                                </button>
                                <div className="input-group-addon">
                                    <a
                                        onClick={() => this.props.onChangeFilter('')}
                                        className={this.props.searchFilter
                                            ? 'clearFilterValue'
                                            : 'clearFilterValue off'
                                        }
                                    >
                                        <img
                                            src={require('../History/assets/clear.png')}
                                            alt="Clear Search"
                                        />
                                    </a>
                                </div>
                            </div>
                            <ul className={this.state.filterOpen
                                ? "dropdown-menu dropDownList show"
                                : "dropdown-menu dropDownList hidden"
                            }>
                                {FilterList}
                            </ul>
                        </div>
                    </div>
                    : null
                }
            </div>
        );
    }
}

export default SearchField;



// WEBPACK FOOTER //
// ./app/components/SelectLists/SearchField.jsx